import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import swal from "sweetalert";
import { Country, State, City } from "country-state-city";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MultiselectorComp from "../../MultiselectorComp/MultiselectorComp";
import api from "../../common/dependencies/utils/Api";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import { SEND_REQUEST_STARTUP__TO_COHORT } from "../../common/constants/ApplicationUrl";
import { getPredefineOptionsList } from "../../AdminModule/Dashboard/AdminDashboard/AdminMentorAction/dependencies/action";
import TextareaField from "../../common/TextAreaField";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import "../modalFilters/styles.scss";
const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    minHeight: "45px",
    color: "#333",
    minWidth:"30rem"
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
};
const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "white",
  },
}));
//Steps to use this component for data:
//1.Create a state variable and send the values as props to this component
//2.set the state here using props.
//3.inside the useEffect of parent , after the setState event occurs value will be reflected

//Steps to hide this Component
//1.create a set variable , use this to toggle visibility.
//2.send both the normal and setValue.
const ModalFiltersNew = (props) => {
  const newCountryArray = [];
  const newsubSpecialArray = [];
  const newsubArray = [];
  const newStateArray = [];
  const classes = useStyles();
  const defaultFormData2 = {
    search: "",
    industry: "",
    subindustry: [],
    specialization: "",
    subspecialization: [],
    stage: "",
    recognized: "",
    state: "",
    state_name: "",
    country: "",
  };
  const [show, setShow] = useState(false);
  const [errorMsg, setError] = useState(false);
  let errorMessageIndustry = ["*Please Select Industry"];
  let errorMessageIndustryKeywords = [
    "*Please Select Industry / Sector - Keywords",
  ];
  let errorMessageFunction = ["*Please Select function of Support"];
  let errorMessageFunctionKeywords = ["*Please Select Function - Keywords"];
  let errorMessageStage = ["*Please Select Stage"];
  // let errorMessagePurpose = ["*Please Enter the purpose"];
  const history = useHistory();
  const [errorVisible, SetErrorVisible] = useState(false);
  const [errorVisible2, SetErrorVisible2] = useState(false);
  const [errorVisible3, SetErrorVisible3] = useState(false);
  const [errorVisible4, SetErrorVisible4] = useState(false);
  const [errorVisible5, SetErrorVisible5] = useState(false);
  const [errorVisible7, SetErrorVisible7] = useState(false);
  const [wordCounter, setWordCounter] = useState(0);
  const [errorMessagePurpose, setErrorMessagePurpose] = useState(
    "*Please Enter the purpose"
  );
  // const [lgShow, setLgShow] = useState(props.modalVisibility);
  const [filterData, setFilterData] = useState();
  const [filterData2, setFilterData2] = useState([]);
  const [filterData3, setFilterData3] = useState();
  const [filterData4, setFilterData4] = useState([]);
  const [filterData5, setFilterData5] = useState();
  const [filterData6, setFilterData6] = useState();
  const [filterData7, setFilterData7] = useState();
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState("");
  const [formData, setFormData] = useState(defaultFormData2);
  const {
    registerMentor,
    getPredefineOptionsList,
    getPredefineOptions,
    viewApplicationData,
  } = props;

  // useEffect(() => {
  //   getPredefineOptionsList();
  //   Country.getAllCountries().map((item) => {
  //     const newObject = {
  //       value: item.isoCode,
  //       label: item.name,
  //     };

  //     newCountryArray.push(newObject);
  //     setNewCountryOptions(newCountryArray);
  //   });
  //   State.getStatesOfCountry("IN").map((item) => {
  //     const newObject = {
  //       value: item.isoCode,
  //       label: item.name,
  //     };

  //     newStateArray.push(newObject);

  //     setNewStateOptions(newStateArray);
  //   });
  // }, []);
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };
      newStateArray.push(newObject);

      setNewStateOptions(newStateArray);
    });
  }, []);
  // useEffect(() => {
  //   const dropdownList =
  //     getPredefineOptions && getPredefineOptions.industry_options.shift();
  //   const dropdownList2 =
  //     getPredefineOptions && getPredefineOptions.functional_areas.shift();
  //   const dropdownList4 =
  //     getPredefineOptions && getPredefineOptions.sub_industry.shift();
  //   const dropdownList5 =
  //     getPredefineOptions && getPredefineOptions._specialisation.shift();
  // }, [getPredefineOptions]);
  const handleFilterChanges = async () => {
    const newsubArray = [];
    const newsubSpecialArray = [];
    let value = localStorage.getItem("SavedLoggedInData");
    let LoginData = JSON.parse(value);
    formData?.subindustry.map((stage) => {
      newsubArray.push(stage.value);
    });
    setFilterData2(newsubArray);
    SetErrorVisible2(false);
    formData?.subspecialization.map((stage) => {
      newsubSpecialArray.push(stage.value);
      setFilterData4(newsubSpecialArray);
      SetErrorVisible4(false);
    });
    if (
      viewApplicationData !== undefined &&
      viewApplicationData !== "" &&
      viewApplicationData !== null
    ) {
      let output;
      output = {
        industry: formData?.industry?.value,
        function: formData?.specialization?.value,
        sub_industry: formData?.subindustry?.value,
        sub_function: formData?.subspecialization?.val,
        stage: formData?.stage?.value,
        purpose: filterData7,
        state: formData?.state_name?.value,
        requestedBy: props.startUpID,
        mentorId: props.mentorID,
      };

      let params = {
        startupId: LoginData.id,
        cohortId: props.cohortId,
        intentToMentor: filterData7,
        requestJson: output,
      };
      await api
        .POST(SEND_REQUEST_STARTUP__TO_COHORT, params)
        .then((response) => {
          const { status, data } = response;
          if (status === 200) {
            setFilterData(undefined);
            setFilterData2(undefined);
            setFilterData3(undefined);
            setFilterData4(undefined);
            setFilterData5(undefined);
            setFilterData6(undefined);
            setFilterData7(undefined);
            // alert("Success")
            props.sendToParent(output);
            setFormData(defaultFormData2);
            if (data?.errors.length > 0) {
              swal({
                title: "Info!",
                text: data?.errors[0]?.message,
                icon: "info",
                // timer: 1500,
                // buttons: false,
              }).then(function () {
                props.setModalVisibility(false);
              });
            } else {
              props.setModalVisibility(false);
              swal({
                title: "Thank You",
                text: `Request Submitted Successfully`,
                icon: "success",
                // timer: 1500,
                // buttons: false,
              }).then(function () {
                if (props.fromModule === "allStartupList") {
                  props.setModalVisibility(false);
                } else if (
                  props.setRedirect !== undefined ||
                  props.fromModule === "startUpDashboard"
                ) {
                  props.setModalVisibility(false);
                  localStorage.setItem("myRequests", "myRequests");
                  window.location.reload();
                } else {
                  props.setModalVisibility(false);
                  localStorage.setItem("myRequests", "myRequests");
                  window.location.reload();
                }
              });
            }
          }
        });
    }
    if (
      filterData !== undefined &&
      filterData !== "select" &&
      filterData3 !== undefined &&
      filterData3 !== "select" &&
      filterData5 !== undefined &&
      filterData5 !== "select" &&
      (filterData2?.length > 0 || filterData4?.length > 0) &&
      (props.fromModule !== null &&
      props.fromModule !== undefined &&
      (props.fromModule === "allMentorsList" ||
        props.fromModule === "allStartupList")
        ? filterData7 !== undefined
        : true)
    ) {
      if (
        (filterData2?.length > 0 && filterData4?.length > 0) ||
        filterData2?.length == 10 ||
        filterData4?.length == 10
      ) {
        let output;
        output = {
          industry: filterData === undefined ? "" : filterData,
          function: filterData3 === undefined ? "" : filterData3,
          sub_industry: newsubArray === undefined ? "" : newsubArray,
          sub_function:
            newsubSpecialArray === undefined ? "" : newsubSpecialArray,
          stage: filterData5 === undefined ? "" : filterData5,
          purpose: filterData7,
          state: filterData6 === undefined ? "" : filterData6,
          requestedBy: props.startUpID,
          mentorId: props.mentorID,
        };

        let params = {
          startupId: LoginData.id,
          cohortId: props.cohortId,
          intentToMentor: filterData7,
          requestJson: output,
        };
        await api
          .POST(SEND_REQUEST_STARTUP__TO_COHORT, params)
          .then((response) => {
            const { status, data } = response;
            if (status === 200) {
              setFilterData(undefined);
              setFilterData2(undefined);
              setFilterData3(undefined);
              setFilterData4(undefined);
              setFilterData5(undefined);
              setFilterData6(undefined);
              setFilterData7(undefined);
              // alert("Success")
              props.sendToParent(output);
              setFormData(defaultFormData2);
              if (data?.errors.length > 0) {
                swal({
                  title: "Info!",
                  text: data?.errors[0]?.message,
                  icon: "info",
                  // timer: 1500,
                  // buttons: false,
                }).then(function () {
                  props.setModalVisibility(false);
                });
              }
            }
          });
      } else {
        if (filterData2.length > 0 || filterData4.length == 10)
          SetErrorVisible2(false);
        else SetErrorVisible2(true);
        if (filterData4.length > 0 || filterData2.length == 10)
          SetErrorVisible4(false);
        else SetErrorVisible4(true);
      }
    } else {
      let output = {
        industry: filterData,
        function: filterData3,
        sub_industry: newsubArray,
        sub_function: newsubSpecialArray,
        stage: filterData5,
        state: filterData6,
        purpose: filterData7,
        requestedBy: LoginData.id,
      };
      if (filterData === undefined) SetErrorVisible(true);
      if (filterData2 === undefined) SetErrorVisible2(true);
      if (filterData3 === undefined) SetErrorVisible3(true);
      if (filterData4 === undefined) SetErrorVisible4(true);
      if (filterData5 === undefined) SetErrorVisible5(true);
      // if (filterData6 === undefined) SetErrorVisible6(true);
      if (filterData7 === undefined) SetErrorVisible7(true);

      if (filterData === undefined || filterData == "select")
        SetErrorVisible(true);
      else SetErrorVisible(false);
      if (filterData2.length > 0 || filterData4.length == 10)
        SetErrorVisible2(false);
      else SetErrorVisible2(true);

      if (filterData3 === undefined || filterData3 == "select")
        SetErrorVisible3(true);
      else SetErrorVisible3(false);
      if (filterData4.length > 0 || filterData2.length == 10)
        SetErrorVisible4(false);
      else SetErrorVisible4(true);
      if (filterData5 === undefined || filterData5 == "select")
        SetErrorVisible5(true);
      else SetErrorVisible5(false);
      if (filterData7 === undefined) SetErrorVisible7(true);
      else if (
        testWordLimit(filterData7) > 0 &&
        testWordLimit(filterData7) < 101
      ) {
        SetErrorVisible7(false);
      }
      // setError(true);
    }
  };
  const handleClose = () => {
    setFilterData(undefined);
    setFilterData2(undefined);
    setFilterData3(undefined);
    setFilterData4(undefined);
    setFilterData5(undefined);
    setFilterData6(undefined);
    setFilterData7(undefined);
    props.setModalVisibility(false);
  };
  const testWordLimit = (data) => {
    let value =
      data?.length === 0
        ? 0
        : data
            ?.replace(/(^\s*)|(\s*$)/gi, "")
            ?.replace(/[ ]{2,}/gi, " ")
            ?.split(" ")?.length;
    if (value == 100) {
      setErrorMessagePurpose("Exceeds word limit reached");
      SetErrorVisible7(true);
    } else if (value < 100 && value > 0) {
      SetErrorVisible7(false);
      setErrorMessagePurpose("*Please Enter the purpose");
    } else if (value == 0) {
      SetErrorVisible7(true);
    } else if (value == 101) {
      setWordCounter(100);
      return value;
    }
    setWordCounter(value);

    return value;
  };
  useEffect(() => {
    if (
      viewApplicationData !== undefined &&
      viewApplicationData !== "" &&
      viewApplicationData !== null
    ) {
      // console.log("first MODAL",viewApplicationData)
      let temp = [];
      let temp2 = [];
      let temp3 = [];
      let temp4 = [];
      let temp5 = [];
      // let temp6=[]

      // setFilterData2(viewApplicationData?.subindustry)

      viewApplicationData?.subindustry.forEach((element) => {
        let obj = {
          label: element,
          value: element,
        };
        temp.push(obj);
      });
      viewApplicationData?.subspecialization.forEach((element) => {
        let obj = {
          label: element,
          value: element,
        };
        temp2.push(obj);
      });
      viewApplicationData?.preffered_stages.forEach((element) => {
        let obj = {
          label: element,
          value: element,
        };
        temp3.push(obj);
      });
      viewApplicationData?.preffered_function.forEach((element) => {
        let obj = {
          label: element,
          value: element,
        };
        temp5.push(obj);
      });
      viewApplicationData?.industrydata.forEach((element) => {
        let obj = {
          label: element,
          value: element,
        };
        temp4.push(obj);
      });
      let temp6 = {
        label: viewApplicationData?.state_name,
        value: viewApplicationData?.state_name,
      };
      // viewApplicationData?.state_name.forEach(element => {
      //   console.log("element state_name",element)
      //   // let obj={
      //   //   label:element,
      //   //   value:element
      //   // }
      //   // temp6.push(obj)
      // });
      setFormData({
        search: "",
        industry: temp4,
        subindustry: temp,
        specialization: temp5,
        subspecialization: temp2,
        stage: temp3,
        recognized: "",
        state: temp6,
        state_name: temp6,
        country: "",
      });

      setFilterData6(temp6);
      testWordLimit(viewApplicationData?.whyneedMentorship);
      setFilterData7(viewApplicationData?.whyneedMentorship);
      // setFilterData(viewApplicationData?.industrydata)
      // setFilterData2(temp)
      // setFilterData4(temp2);
      // console.log("TEMP",temp,"temp2",temp2)
      // // setFilterData4(viewApplicationData?.subspecialization)
      // setFilterData5(viewApplicationData?.preffered_stages)
      // setFilterData6(viewApplicationData?.state)
    }
  }, [viewApplicationData]);
  return (
    <>
      <Modal
        size="lg"
        show={props.modalVisibility}
        onHide={() => props.setModalVisibility(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ borderRadius: "7px" }}
      >
        <Modal.Header className="d-flex ">
          <Modal.Title className="modalHeading">JOIN COHORT</Modal.Title>
          <div className="newuserTooltip">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            />
            <span
              className="tooltiptext  close-window"
              style={{ left: "-120px", top: "2px", width: "120px" }}
            >
              Close Window
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center">
            <div
              className="d-flex mt-2 startupstepsforms"
              style={{ maxWidth: "33rem", flexDirection: "column" }}
            >
              <h6 className="mt-2">Industry (Select 1 Industry) *</h6>
              <MultiselectorComp
                hideSelectedOptions={false}
                styles={customStyles}
                placeholder="Select Industry"
                options={
                  getPredefineOptions && getPredefineOptions.industry_options
                }
                onChange={(e) => {
                  setFormData((user) => {
                    return { ...user, industry: e };
                  });
                  // setFormData((user) => {
                  //   return { ...user, state_name: e.label };
                  // });
                }}
                // onChange={(e) => {
                //   setFilterData(e.value);
                //   SetErrorVisible(false);
                // }}
                closeMenuOnSelect={true}
                value={formData.industry}
                // value={{value:viewApplicationData?.industrydata,label:viewApplicationData?.industrydata}}
                // defaultValue={{value : viewApplicationData?.industrydata, label: viewApplicationData?.industrydata}}
              />
              {errorVisible && (
                <div className="login-error-msg mt-2">
                  {errorMessageIndustry}
                </div>
              )}
              {/* <h6 className="mt-2">
                Industry / Sector - Keywords (Industry/Function Keywords select
                up to 10) *
              </h6>
              <MultiselectorComp
                options={
                  getPredefineOptions && getPredefineOptions.sub_industry
                }
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                styles={customStyles}
                placeholder="Industry/Sector Keywords"
                onChange={(list) =>
                  list.length <= 10 - formData.subspecialization.length
                    ? setFormData((user) => {
                        SetErrorVisible2(false);
                        let arr = list.filter(function (item) {
                          return item.value !== "select";
                        });
                        let newArr = [];
                        arr.forEach((item) => {
                          newArr.push(item.value);
                        });
                        setFilterData2(newArr);
                        if (
                          list.length + formData.subspecialization.length ==
                          10
                        ) {
                          swal({
                            title: "Info!",
                            text: "Maximum 10 keywords limit reached.",
                            icon: "info",
                          });
                        }
                        return { ...user, subindustry: arr };
                      })
                    : null
                }
                value={formData.subindustry}
              /> */}
              {/* {errorVisible2 && (
                <div className="login-error-msg mt-2">
                  {errorMessageIndustryKeywords}
                </div>
              )} */}
              <h6 className="mt-2">Function (Select 1 Function) *</h6>
              <MultiselectorComp
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                placeholder="Select Function"
                styles={customStyles}
                options={
                  getPredefineOptions && getPredefineOptions._specialisation
                }
                onChange={(e) => {
                  // setFilterData6(e.label);
                  setFormData((user) => {
                    return { ...user, specialization: e };
                  });
                  // setFormData((user) => {
                  //   return { ...user, state_name: e.label };
                  // });
                }}
                // onChange={(e) => {
                //   setFilterData3(e.value);
                //   SetErrorVisible3(false);
                // }}
                value={formData.specialization}
                // defaultValue={{value : viewApplicationData?.preffered_function, label: viewApplicationData?.preffered_function}}
              />
              {errorVisible3 && (
                <div className="login-error-msg mt-2">
                  {errorMessageFunction}
                </div>
              )}
              {/* <h6 className="mt-2">
                Function - Keywords (Industry/Function Keywords select up to 10)
                *
              </h6>

              <MultiselectorComp
                options={
                  getPredefineOptions && getPredefineOptions.functional_areas
                }
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                placeholder="Function Keywords"
                styles={customStyles}
                onChange={(list) =>
                  list.length <= 10 - formData.subindustry.length
                    ? setFormData((user) => {
                        SetErrorVisible4(false);
                        let arr = list.filter(function (item) {
                          return item.value !== "select";
                        });
                        let newArr = [];
                        arr.forEach((item) => {
                          newArr.push(item.value);
                        });
                        setFilterData4(newArr);
                        if (list.length + formData.subindustry.length == 10) {
                          swal({
                            title: "Info",
                            text: "Maximum 10 keywords limit reached.",
                            icon: "info",
                          });
                        }
                        return { ...user, subspecialization: arr };
                      })
                    : null
                }
                value={formData.subspecialization}
                // value={filterData4}
              />
              {errorVisible4 && (
                <div className="login-error-msg mt-2">
                  {errorMessageFunctionKeywords}
                </div>
              )} */}
              <h6 className="mt-2">
                Current Stage of the Startup (Select 1 Stage) *
              </h6>
              <MultiselectorComp
                hideSelectedOptions={false}
                styles={customStyles}
                placeholder="Select Stage"
                options={
                  getPredefineOptions &&
                  getPredefineOptions.stage_of_startup_options
                }
                // isClearable={true}
                onChange={(e) => {
                  // setGender(e.value);
                  // console.log("selected Gender", e);
                  // setFilterData5(e.value);
                  setFormData((user) => {
                    return { ...user, stage: e };
                  });
                }}
                // onChange={(e) => {
                //   setFilterData5(e.value);
                //   SetErrorVisible5(false);
                // }}
                closeMenuOnSelect={true}
                value={formData.stage}
                // value={{value:viewApplicationData?.preffered_stages,label:viewApplicationData?.preffered_stages}}
                // defaultValue={{value : viewApplicationData?.preffered_stages, label: viewApplicationData?.preffered_stages}}
              />
              {errorVisible5 && (
                <div className="login-error-msg mt-2">{errorMessageStage}</div>
              )}
              {props.fromModule !== null &&
                props.fromModule !== undefined &&
                (props.fromModule === "allMentorsList" ||
                  props.fromModule === "allStartupList") && (
                  <>
                    <h6 className="mt-2">
                      Purpose of Request (max 100 words)*
                    </h6>
                    <TextareaField
                      id="purpose"
                      variant="outlined"
                      placeholder="Describe in maximum 100 words"
                      fullWidth
                      margin="normal"
                      style={{ backgroundColor: "white" }}
                      name="purpose"
                      rows={2}
                      InputProps={{ className: classes.input }}
                      // className="purposeBox"
                      maxRows={4}
                      value={filterData7}
                      // defaultValue={viewApplicationData?.whyneedMentorship}
                      onChange={(e) => {
                        if (testWordLimit(e.target.value) < 101) {
                          setFilterData7(e.target.value);
                        }
                      }}
                    />
                    <div className="wordCounter d-flex justify-content-end">
                      Word Count: {wordCounter} / 100
                    </div>
                    {errorVisible7 && (
                      <div className="login-error-msg mt-2">
                        {errorMessagePurpose}
                      </div>
                    )}
                  </>
                )}

              {/* <div className="lastFilter">
                <h6 className="">State</h6>
                <Select
                  required={true}
                  id="state"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  type="State"
                  name="state"
                  className="col-12 "
                  styles={customStyles}
                  value={formData.state}
                  onChange={(e) => {
                    // setFilterData6(e.label);
                    setFormData((user) => {
                      return { ...user, state: e };
                    });
                    setFormData((user) => {
                      return { ...user, state_name: e.label };
                    });
                  }}
                  options={newStateOptions}
                  placeholder="State"
                  // value={formData.state}
                  // defaultValue={{value : viewApplicationData?.state_name, label: viewApplicationData?.state_name}}
                />
              </div> */}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            onClick={handleFilterChanges}
            text="Submit"
            className="modalButton"
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, {
  getPredefineOptionsList,
})(withRouter(ModalFiltersNew));
